import {
  INICIALITZAR,
  OBTENIR_DADES_CREACIO_INDIVIDU
} from "../actions/actionTypes";

const ESTAT_INICIAL = {};

const generes = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_SUCCESS`:
      return action.payload.generes;

    default:
      return state;
  }
};

export default generes;

const totsGeneres = state => state.generes;

export const getGeneres = state => {
  const generes = totsGeneres(state);

  if (!generes) {
    return null;
  }
  return generes;
};
